import { NetworkError } from '@/features/graphql/types'
import { isNetworkError } from '@/features/graphql/utils'
import { ApolloLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { getNetworkStateAsync } from 'expo-network'

const missingNetworkConnectionContextLink = setContext(async (_, prevContext) => {
    try {
        const { isConnected } = await getNetworkStateAsync()

        return { ...prevContext, missingNetworkConnection: !isConnected }
    } catch {
        return prevContext
    }
})

export const missingNetworkConnectionErrorLink = onError((errorResponse) => {
    if (!isNetworkError(errorResponse)) return

    const { missingNetworkConnection } = errorResponse.operation.getContext()

    if (!missingNetworkConnection) return
    ;(errorResponse.networkError as NetworkError).missingNetworkConnection = true
})

export const missingNetworkConnectionLink = ApolloLink.from([
    missingNetworkConnectionContextLink,
    missingNetworkConnectionErrorLink,
])
